import axios from "axios";
import { loadAndTrack } from "redux-request-loading";
import { Dispatch } from "redux";

import { QUESTIONNAIRE_KEY as employeeQuestionnaireKey } from "@teamprevent/common/ppq/components/PpqEmployeeForm";
import { QUESTIONNAIRE_KEY as managerQuestionnaireKey } from "@teamprevent/common/ppq/components/PpqManagerSection";
import { questionnaireLoaded, clearQuestionnaire } from "@teamprevent/common/questionnaires/actions";

import { AnsweredQuestionWithId } from "@teamprevent/common/model";

import { LOAD_PPQ_DETAILS, CREATE_PPQ } from "./actionTypes";
import { PpqApi } from "./PpqApi";

const ppqApi = new PpqApi(axios);

export function loadPpqDetails({ ohCaseId }: { ohCaseId: string }) {
    return async (dispatch: Dispatch) => {
        dispatch(clearQuestionnaire(employeeQuestionnaireKey));
        dispatch(clearQuestionnaire(managerQuestionnaireKey));
        const result = await loadAndTrack(dispatch, LOAD_PPQ_DETAILS, ppqApi.get(ohCaseId));
        dispatch(questionnaireLoaded({
            questions: result.employeeQuestionnaire.data ? result.employeeQuestionnaire.data.questions : [],
            questionnaireKey: employeeQuestionnaireKey
        }));
        dispatch(questionnaireLoaded({ questions: result.managersQuestionnaire.data.questions, questionnaireKey: managerQuestionnaireKey }));
    };
}

export const createPpq = (customerId: string, employeeId: string, managerSection: AnsweredQuestionWithId[], employeeSection: AnsweredQuestionWithId[]) =>
    async (dispatch: Dispatch) => {
        const response = await loadAndTrack<string>(dispatch, CREATE_PPQ, ppqApi.create(customerId, employeeId, managerSection, employeeSection));
        return response;
    };

export const loadUnmatchedPpqDetails = (customerId: string, ppqId: string) =>
    async (dispatch: Dispatch) => {
        dispatch(clearQuestionnaire(employeeQuestionnaireKey));
        dispatch(clearQuestionnaire(managerQuestionnaireKey));
        const result = await loadAndTrack(dispatch, LOAD_PPQ_DETAILS, ppqApi.getUnmatched(customerId, ppqId));
        dispatch(questionnaireLoaded({ questions: result.data.questions, questionnaireKey: managerQuestionnaireKey }));
    };
